import styled from 'styled-components';

import { ReactComponent as TrashSvg } from 'assets/trash-icon.svg';
import ButtonComponent from 'components/b2b/Button';
import ColormapInterface from 'shared-types/colormapinterface';
import { fontSize, fontWeight, getSpacing, lineHeight, letterSpacing } from 'stylesheetB2b';

export const TrashIcon = styled(TrashSvg) <{ colors: ColormapInterface }>`
  color: ${({ colors }) => colors.modalIcon};
  margin-bottom: ${getSpacing(6)};
`;
TrashIcon.displayName = 'TrashIcon';

export const Message = styled.p<{ colors: ColormapInterface }>`
  color: ${({ colors }) => colors.waitingListDeleteConfirmationModalMessage};
  letter-spacing: ${letterSpacing.small};
  text-align: center;
  padding: 0 ${getSpacing(9)};
  font-size: ${fontSize.small};
  margin-bottom: ${getSpacing(4)};
  font-weight: ${fontWeight.light};
  line-height: ${lineHeight.small};
`;
Message.displayName = 'Message';

export const Button = styled(ButtonComponent)`
  height: ${getSpacing(7)};
  margin-bottom: ${getSpacing(2)};

  :not(:last-child) {
    margin-bottom: ${getSpacing(2)};
  }
`;
Button.displayName = 'Button';
